import React from 'react';

import { AnimatePresence, motion } from 'framer-motion';

import { useAppSelector } from '@pkg/hooks';

import { type ArtifactType } from '@app/client/common/structs/nft/artifacts';
import { userArtifacts } from '@app/store/selectors/artifacts/artifacts';

import './ArtifactsBackdrop.scss';

// use "baked" (optimized, not transparent) versions of these images
const ARTIFACT_BACKGROUND_PATH: Record<ArtifactType, string> = {
    CelestialRose: 'seed',
    CloudSeed: 'seed',
    PrismCase: 'prismcase',
    PrismKey: 'prismkey',
    Yat: '',
};

interface ArtifactsBackdropProps {
    activeArtifactType: ArtifactType;
}

export function ArtifactsBackdrop({ activeArtifactType }: ArtifactsBackdropProps) {
    let backdropElement;
    const { totalKeys } = useAppSelector(userArtifacts);

    totalKeys.forEach((thisArtifactType: ArtifactType) => {
        if (activeArtifactType === thisArtifactType) {
            backdropElement = (
                <motion.div
                    key={`artifact-backdrop-${thisArtifactType}`}
                    className="yat-artifacts__backdrops__image"
                    style={{
                        backgroundImage: `url('/assets/img/artifacts/backdrops/${ARTIFACT_BACKGROUND_PATH[thisArtifactType]}_baked.jpg')`,
                    }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 1, delay: 0.25 }}
                />
            );
        }
    });

    return (
        <div className="yat-artifacts__backdrops">
            <AnimatePresence>{backdropElement}</AnimatePresence>
        </div>
    );
}
